import React, { useState } from 'react';
import { API, authFetch } from '../utils/api';
import AuctionCountdown from './AuctionCountdown';
import TrustBadge from './TrustBadge';
import ConsentBadge from './ConsentBadge';

// 경매 카드 — 사진 + 사고뱃지 + 즐겨찾기 + 가격 + 카운트다운 + 신뢰도
function AuctionCard(props){
  var auction=props.auction||{};
  var onClick=props.onClick;
  var onFavoriteChange=props.onFavoriteChange;

  var initialFavCount=(auction.liveStats&&auction.liveStats.favoriteCount)||0;
  var initialIsFav=!!(auction.myStatus&&auction.myStatus.isFavorite);
  var[favCount,setFavCount]=useState(initialFavCount);
  var[isFav,setIsFav]=useState(initialIsFav);
  var[favLoading,setFavLoading]=useState(false);

  // 사진 경로 해석 — 카드는 썸네일(400px) 선호, 로드 실패 시 원본으로 폴백
  var firstPhoto=auction.photos&&auction.photos.length>0?auction.photos[0]:null;
  var rawUrl=firstPhoto?(firstPhoto.thumbnail||firstPhoto.url||''):'';
  var photoUrl='';
  if(rawUrl){
    if(rawUrl.indexOf('http')===0)photoUrl=rawUrl;
    else if(rawUrl.charAt(0)==='/')photoUrl=API.replace('/api','')+rawUrl;
    else photoUrl=API.replace('/api','')+'/'+rawUrl;
  }
  var fallbackUrl=firstPhoto&&firstPhoto.url?(firstPhoto.url.indexOf('http')===0?firstPhoto.url:firstPhoto.url.charAt(0)==='/'?API.replace('/api','')+firstPhoto.url:API.replace('/api','')+'/'+firstPhoto.url):'';

  var inspection=auction.inspection||{};
  var summary=inspection.summary||'검차없음';
  var summaryColor=inspection.summaryColor||'#94a3b8';

  var bidCount=(auction.liveStats&&auction.liveStats.bidCount)||0;
  var viewCount=(auction.liveStats&&auction.liveStats.viewCount)||0;

  var status=auction.status;
  var isSold=status==='sold';
  var isPending=status==='pending_selection';
  var isCancelled=status==='cancelled'||status==='failed'||status==='rejected_all'||status==='expired_selection';

  var toggleFav=function(e){
    e.stopPropagation();
    if(favLoading)return;
    setFavLoading(true);
    var prevFav=isFav;
    var prevCount=favCount;
    // 낙관적 업데이트
    var newFav=!prevFav;
    setIsFav(newFav);
    setFavCount(prevCount+(newFav?1:-1));
    authFetch(API+'/auctions/'+auction.id+'/favorite',{method:'POST'})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          setIsFav(d.data.isFavorite);
          setFavCount(d.data.favoriteCount);
          if(onFavoriteChange)onFavoriteChange(auction.id,d.data);
        }else{
          setIsFav(prevFav);
          setFavCount(prevCount);
        }
      })
      .catch(function(){setIsFav(prevFav);setFavCount(prevCount)})
      .then(function(){setFavLoading(false)});
  };

  var handleClick=function(){
    if(onClick)onClick(auction);
  };

  var yearLabel=auction.car&&auction.car.year?auction.car.year+' ':'';
  var modelLabel=(auction.car&&auction.car.model)||auction.title||'경매 차량';
  var mileageLabel=auction.car&&auction.car.mileage?Number(auction.car.mileage).toLocaleString()+' km':'';
  var carNoLabel=auction.car&&auction.car.number?auction.car.number:'';

  var sellerName=(auction.seller&&auction.seller.displayName)||'출품업체';
  var trustBadge=auction.seller&&auction.seller.trustBadge;

  return (
    <div onClick={handleClick}
      style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'hidden',cursor:'pointer',transition:'transform 0.2s, box-shadow 0.2s',position:'relative',opacity:isCancelled?0.55:1,display:'flex',flexDirection:'column'}}
      onMouseEnter={function(e){e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.12)';e.currentTarget.style.transform='translateY(-2px)'}}
      onMouseLeave={function(e){e.currentTarget.style.boxShadow='none';e.currentTarget.style.transform='none'}}>

      {/* 상단 배너: 낙찰자 선택 중 */}
      {isPending&&(
        <div style={{background:'#fbbf24',color:'#78350f',padding:'6px 12px',fontSize:11,fontWeight:700,textAlign:'center',letterSpacing:0.3}}>
          🏆 낙찰자 선택 중
        </div>
      )}

      {/* 사진 영역 (62% paddingTop = 약 16:10) */}
      <div style={{position:'relative',width:'100%',paddingTop:'62%',background:'#f1f5f9',overflow:'hidden'}}>
        {photoUrl?(
          <img src={photoUrl} alt={modelLabel}
            loading="lazy" decoding="async"
            style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',objectFit:'cover'}}
            onError={function(e){
              // 썸네일 실패 시 원본으로 폴백 (1회만 시도)
              if(fallbackUrl&&e.currentTarget.src!==fallbackUrl){e.currentTarget.src=fallbackUrl;return}
              e.currentTarget.style.display='none';
            }}/>
        ):(
          <div style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:56,color:'#cbd5e1'}}>🚗</div>
        )}

        {/* 사고 뱃지 */}
        <div style={{position:'absolute',top:8,left:8,padding:'4px 10px',borderRadius:6,background:summaryColor,color:'#fff',fontSize:11,fontWeight:700,boxShadow:'0 2px 6px rgba(0,0,0,0.25)',letterSpacing:0.2}}>
          {summary}
        </div>

        {/* Wave 2.4: 소유자 동의 완료 뱃지 (owner_consent_given=1일 때만 표시) */}
        {auction.car&&auction.car.owner_consent_given?(
          <div style={{position:'absolute',top:8,left:'50%',transform:'translateX(-50%)',zIndex:2}}>
            <ConsentBadge
              ownerConsentGiven={auction.car.owner_consent_given}
              ownerConsentMethod={auction.car.owner_consent_method}
              size="sm"
            />
          </div>
        ):null}

        {/* 즐겨찾기 하트 */}
        <button onClick={toggleFav} disabled={favLoading}
          style={{position:'absolute',top:8,right:8,width:34,height:34,borderRadius:'50%',border:'none',background:'rgba(255,255,255,0.95)',cursor:favLoading?'wait':'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,fontWeight:700,boxShadow:'0 2px 8px rgba(0,0,0,0.2)',transition:'transform 0.15s',color:isFav?'#ef4444':'#94a3b8',padding:0}}
          onMouseDown={function(e){e.currentTarget.style.transform='scale(0.82)'}}
          onMouseUp={function(e){e.currentTarget.style.transform='scale(1)'}}
          onMouseLeave={function(e){e.currentTarget.style.transform='scale(1)'}}>
          {isFav?'♥':'♡'}
        </button>

        {/* 낙찰 완료 스탬프 */}
        {isSold&&(
          <div style={{position:'absolute',inset:0,background:'rgba(15,23,42,0.45)',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div style={{padding:'10px 26px',background:'rgba(220,38,38,0.95)',color:'#fff',fontSize:17,fontWeight:800,letterSpacing:3,border:'3px solid #fff',borderRadius:6,transform:'rotate(-8deg)',boxShadow:'0 4px 14px rgba(0,0,0,0.5)'}}>
              낙찰완료
            </div>
          </div>
        )}

        {/* 취소/실패/유찰 */}
        {isCancelled&&(
          <div style={{position:'absolute',inset:0,background:'rgba(100,116,139,0.55)',display:'flex',alignItems:'center',justifyContent:'center'}}>
            <div style={{padding:'8px 20px',background:'rgba(71,85,105,0.95)',color:'#fff',fontSize:14,fontWeight:700,letterSpacing:2,borderRadius:4}}>
              {status==='failed'?'유찰':status==='rejected_all'?'전체 거절':status==='expired_selection'?'선택 만료':'취소'}
            </div>
          </div>
        )}
      </div>

      {/* 정보 영역 */}
      <div style={{padding:'12px 14px',display:'flex',flexDirection:'column',flex:1}}>
        <div style={{fontSize:15,fontWeight:700,color:'#0f172a',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
          {yearLabel}{modelLabel}
        </div>
        <div style={{fontSize:11,color:'#64748b',marginTop:3,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
          {mileageLabel}{mileageLabel&&carNoLabel?' · ':''}{carNoLabel}
        </div>

        {/* 입찰 현황 */}
        <div style={{marginTop:10,paddingTop:10,borderTop:'1px solid #f1f5f9'}}>
          <div style={{fontSize:10,color:'#94a3b8',letterSpacing:0.3}}>입찰</div>
          <div style={{fontSize:19,fontWeight:800,color:bidCount>0?'#1B3A5C':'#94a3b8',lineHeight:1.2,marginTop:2}}>
            {bidCount>0?bidCount+'건':'자유 입찰'}
          </div>
        </div>

        {/* 메타: 조회/입찰/즐겨찾기 + 카운트다운 */}
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10,fontSize:11,color:'#64748b',gap:6}}>
          <div style={{display:'flex',gap:9,whiteSpace:'nowrap'}}>
            <span>👁 {viewCount}</span>
            <span>🔨 {bidCount}</span>
            <span>♡ {favCount}</span>
          </div>
          <AuctionCountdown timeRemaining={auction.timeRemaining} size="sm"/>
        </div>

        {/* 출품자 + 신뢰도 */}
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:10,paddingTop:10,borderTop:'1px solid #f1f5f9',gap:8}}>
          <div style={{fontSize:11,color:'#475569',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',flex:1,fontWeight:500}}>
            {sellerName}
          </div>
          {trustBadge&&<TrustBadge badge={trustBadge} size="sm"/>}
        </div>
      </div>
    </div>
  );
}

export default AuctionCard;
